import { ChangeEvent, useContext, useState } from 'react';
import { Button, TableCell, TableRow, TableContainer, Table, TableHead, TableBody, Dialog, DialogActions, FormControlLabel, Checkbox, FormGroup, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StockCountCreateContext, StockCountCreateValues } from '../../contexts/StockCountCreateContext';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';
import { productTypes } from './../../../../pages/CreateStockCount/interfaces/StockInterfaces';

const StockCountCreateTypesModal = () => {
  const { isProductTypeModalOpen,
    handleClose,
    productTypeData,
    handleProductTypes } = useContext(StockCountCreateContext) as StockCountCreateValues;

  const [tempProductTypeData, setTempProductTypeData] = useState<string[]>(productTypeData ?? []);
  const { t } = useTranslation('createStockCount');

  const addItemToTempList = (item: string) => {
    setTempProductTypeData([...tempProductTypeData, item]);
  };

  const handleConfirm = () => {
    handleProductTypes(tempProductTypeData);
    setTempProductTypeData([]);
  };

  const handleProductTypeCheckboxChange = (productType: string, isChecked: boolean) => {
    if (isChecked) {
      if (!tempProductTypeData?.includes(productType)) {
        addItemToTempList(productType);
      }
      return;
    } 
    setTempProductTypeData(prevData => 
      prevData?.filter(row => row !== productType) || [],
    );
  };

  const handleSelectAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    if (checked) {
      setTempProductTypeData(productTypes);
    } else {
      setTempProductTypeData([]);
    }
  };

  return (
    <Dialog open={isProductTypeModalOpen}
      onClose={handleClose}
      maxWidth='md'
      fullWidth>
      <DialogTitle>
        {t('types')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        <TableContainer sx={{ overflowy: 'auto', border: '1px solid' }}
          style={{ maxHeight: '400px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell >{t('type')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productTypes.map((row) => (
                <TableRow key={row}>
                  <TableCell style={{ display: 'flex', alignItems: 'center' }}  >
                    <Checkbox
                      color="primary"
                      inputProps={{
                        'aria-label': `select type ${row}`,
                      }}
                      checked={tempProductTypeData?.some((item) => item === row)}
                      onChange={(e) =>
                        handleProductTypeCheckboxChange(
                          row,
                          e.target.checked,
                        )
                      } />
                    {t(row?.toLowerCase() ?? '')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <FormGroup sx={{ pt: '10px' }}>
          <FormControlLabel
            control={<Checkbox onChange={handleSelectAllChange}
              checked={productTypes.length === tempProductTypeData.length} />}
            label="Select all types" />
        </FormGroup>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          size='lg'
          onClick={handleClose}> {t('cancel')}</Button>
        <Button
          size='lg'
          onClick={handleConfirm}>
          {t('confirm')}
        </Button>
      </DialogActions>
    </Dialog>

  );
};

export default StockCountCreateTypesModal;